// Маршруты — по таблице docs/domain.md §2. Пути объявлены здесь и только здесь,
// это единственный источник правды для <Route path>.

import { lazyPage } from './lazyPage'

export const ROUTE_PATHS = {
  onboarding: '/onboarding/*',
  home: '/',
  compat: '/compat',
  compatTarget: '/compat/target',
  compatResult: '/compat/result/:id',
  links: '/links',
  linkPerson: '/links/:linkId',
  linksInbox: '/links/inbox',
  stats: '/stats',
  profile: '/profile',
  profilePrivacy: '/profile/privacy',
  profileHistory: '/profile/history',
  natal: '/natal',
  natalData: '/natal/data',
  natalResult: '/natal/result',
  natalHouses: '/natal/houses',
  natalDeep: '/natal/points',
  natalOther: '/natal/other',
  natalOtherResult: '/natal/other/result',
  bowl: '/bowl',
  subscription: '/subscription',
  subscriptionThanks: '/subscription/thanks',
  /** Гейт подписки на канал. Экран без выхода: уйти можно только подписавшись. */
  gate: '/gate',
} as const

export const OnboardingPage = lazyPage(() =>
  import('~/pages/onboarding/OnboardingPage').then((m) => ({ default: m.OnboardingPage })),
)
export const HomePage = lazyPage(() =>
  import('~/pages/home/HomePage').then((m) => ({ default: m.HomePage })),
)
export const CompatStepTypePage = lazyPage(() =>
  import('~/pages/compat/CompatStepTypePage').then((m) => ({ default: m.CompatStepTypePage })),
)
export const CompatStepTargetPage = lazyPage(() =>
  import('~/pages/compat/CompatStepTargetPage').then((m) => ({
    default: m.CompatStepTargetPage,
  })),
)
export const CompatResultPage = lazyPage(() =>
  import('~/pages/compat/CompatResultPage').then((m) => ({ default: m.CompatResultPage })),
)
export const LinksCanvasPage = lazyPage(() =>
  import('~/pages/links/LinksCanvasPage').then((m) => ({ default: m.LinksCanvasPage })),
)
export const PersonPage = lazyPage(() =>
  import('~/pages/links/PersonPage').then((m) => ({ default: m.PersonPage })),
)
export const InboxPage = lazyPage(() =>
  import('~/pages/links/InboxPage').then((m) => ({ default: m.InboxPage })),
)
export const StatsPage = lazyPage(() =>
  import('~/pages/stats/StatsPage').then((m) => ({ default: m.StatsPage })),
)
export const ProfilePage = lazyPage(() =>
  import('~/pages/profile/ProfilePage').then((m) => ({ default: m.ProfilePage })),
)
export const PrivacyPage = lazyPage(() =>
  import('~/pages/profile/PrivacyPage').then((m) => ({ default: m.PrivacyPage })),
)
export const CompatHistoryPage = lazyPage(() =>
  import('~/pages/profile/CompatHistoryPage').then((m) => ({ default: m.CompatHistoryPage })),
)
export const NatalIntroPage = lazyPage(() =>
  import('~/pages/natal/NatalIntroPage').then((m) => ({ default: m.NatalIntroPage })),
)
export const NatalDataPage = lazyPage(() =>
  import('~/pages/natal/NatalDataPage').then((m) => ({ default: m.NatalDataPage })),
)
export const NatalResultPage = lazyPage(() =>
  import('~/pages/natal/NatalResultPage').then((m) => ({ default: m.NatalResultPage })),
)
export const NatalOtherResultPage = lazyPage(() =>
  import('~/pages/natal/NatalOtherResultPage').then((m) => ({ default: m.NatalOtherResultPage })),
)
export const BowlPage = lazyPage(() =>
  import('~/pages/bowl/BowlPage').then((m) => ({ default: m.BowlPage })),
)
export const SubscriptionPage = lazyPage(() =>
  import('~/pages/subscription/SubscriptionPage').then((m) => ({ default: m.SubscriptionPage })),
)

export const SubscriptionThanksPage = lazyPage(() =>
  import('~/pages/subscription/SubscriptionThanksPage').then((m) => ({
    default: m.SubscriptionThanksPage,
  })),
)
export const ChannelGatePage = lazyPage(() =>
  import('~/pages/gate/ChannelGatePage').then((m) => ({ default: m.ChannelGatePage })),
)
export const WebStubPage = lazyPage(() =>
  import('~/pages/webStub/WebStubPage').then((m) => ({ default: m.WebStubPage })),
)

export const NotFoundPage = lazyPage(() =>
  import('~/pages/notFound/NotFoundPage').then((m) => ({ default: m.NotFoundPage })),
)
